(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('auto-fax', {
                parent: 'entity',
                url: '/auto-fax',
                data: {
                    pageTitle: 'AutoFaxes'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/auto-fax/list/auto-fax.html',
                        controller: 'AutoFaxController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    access: ['Auth', 'ACTIONS', function (Auth, ACTIONS) {
                        var actions = [ACTIONS.ACTION_MAIN_MENU_CONFIG_AUTO_FAX];
                        return Auth.loadActionsAccess(actions).$promise;
                    }]
                },
                onEnter: ['Auth', 'ACTIONS', 'access', function (Auth, ACTIONS, access) {
                    Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_AUTO_FAX, access);
                }]
            })
    }
})();
